import { useEffect, useState } from 'react';
import { AuthProvider, useAuth } from './auth/AuthContext.js';
import { primeTtsStatus } from './lib/tts.js';
import { Login } from './screens/Login.js';
import { AcceptInvite } from './screens/AcceptInvite.js';
import { Shell, allowedScenes, type SceneKey } from './components/Shell.js';
import { Today } from './screens/Today.js';
import { Reflect } from './screens/Reflect.js';
import { Align } from './screens/Align.js';
import { Vault } from './screens/Vault.js';
import { Converse } from './screens/Converse.js';
import { Professional } from './screens/Professional.js';

function Inner() {
  const { user, loading } = useAuth();
  const [scene, setScene] = useState<SceneKey>('today');

  // Once signed in, learn whether the server's cloned voice is configured so the
  // whole app (incl. invited visitors) defaults to it.
  useEffect(() => { if (user) void primeTtsStatus(); }, [user]);

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-ink/40 text-[12px]">
        loading…
      </div>
    );
  }
  if (!user) {
    const inviteToken = new URLSearchParams(window.location.search).get('token');
    return inviteToken ? <AcceptInvite token={inviteToken} /> : <Login />;
  }

  // Clamp the scene to what this role may see (visitors get Converse [+ Pro]).
  const allowed = allowedScenes(user);
  const activeScene: SceneKey = allowed.includes(scene) ? scene : allowed[0]!;

  return (
    <Shell active={activeScene} onChange={(s) => setScene(allowed.includes(s) ? s : allowed[0]!)}>
      {activeScene === 'today' && <Today />}
      {activeScene === 'reflect' && <Reflect />}
      {activeScene === 'align' && <Align />}
      {activeScene === 'vault' && <Vault />}
      {activeScene === 'converse' && <Converse />}
      {activeScene === 'pro' && <Professional onConverse={() => setScene('converse')} />}
    </Shell>
  );
}

export function App() {
  return (
    <AuthProvider>
      <Inner />
    </AuthProvider>
  );
}
